import styled from "styled-components";

import { Button } from "@/components/Form";
import { IThemeProps } from "@/styles";

export const TextBox = styled.div`
  display: block;
  margin: 0 auto;
  max-width: 500px;
  @media ${(props: any) => props.theme.breakpoints.mobile} {
    max-width: 296px;
  }
  padding: 0 ${(props: any) => props.theme.spacing.desktop.s100}px;
  color: ${(props: any) => props.theme.colors.fontTextLight};
  text-align: center;
`;

export const Summary = styled.div`
  width: 100%;
  padding-bottom: ${(props: any) => props.theme.spacing.desktop.s500}px;

  @media ${(props: any) => props.theme.breakpoints.mobile} {
    padding-bottom: ${(props: any) => props.theme.spacing.mobile.s200}px;
  }
`;

export const VoteButton = styled(Button)`
  width: 396px;
  @media ${(props: any) => props.theme.breakpoints.mobile} {
    width: 296px;
  }
  max-width: unset;
  margin: 20px auto;
`;

export const InvertedButton = styled(Button)`
  width: 396px;
  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    width: 296px;
  }
  background-color: ${(props: IThemeProps) =>
    props.theme.colors.buttonSecondaryBackground};
  border-width: ${(props: IThemeProps) => props.theme.borders.buttonSecondary};
  border-color: ${(props: IThemeProps) => props.theme.colors.buttonSecondary};
  color: ${(props: IThemeProps) => props.theme.colors.buttonSecondary};
  max-width: unset;
  margin: 20px auto;
  svg {
    path {
      fill: ${(props: IThemeProps) => props.theme.colors.buttonSecondary};
    }
  }

  ${({ theme: { globals, colors } }: IThemeProps) =>
    !globals.isTouch &&
    `&:hover {
      color: ${colors.white};
      border-color: ${colors.button};
      background-color: ${colors.button};
      svg {
        path {
          fill: ${colors.white};
        }
      }
    }`}
`;

const ArrowWrapper = styled.div`
  position: absolute;
  display: flex;
`;

export const LeftArrowWrapper = styled(ArrowWrapper)`
  left: 10px;
`;

export const RightArrowWrapper = styled(ArrowWrapper)`
  right: 10px;
`;
